import { render, staticRenderFns } from "./SystemHeader.vue?vue&type=template&id=0f0b7f89&scoped=true"
import script from "./SystemHeader.vue?vue&type=script&lang=js"
export * from "./SystemHeader.vue?vue&type=script&lang=js"
import style0 from "./SystemHeader.vue?vue&type=style&index=0&id=0f0b7f89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0b7f89",
  null
  
)

export default component.exports